import { render, staticRenderFns } from "./ClientMenuWrapper.vue?vue&type=template&id=2f90fb38&"
import script from "./ClientMenuWrapper.vue?vue&type=script&lang=js&"
export * from "./ClientMenuWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports